module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.crumbs
    }
  }, [_c('div', {
    staticClass: "row d-flex align-items-center justify-content-end pr-15"
  }, [_c('authorized-link', {
    attrs: {
      "tag": "create_contract"
    }
  }, [_c('router-link', {
    staticClass: "ls-btn-primary ls-no-margin ls-xs-margin-bottom",
    attrs: {
      "to": {
        name: 'contracts_new'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-plus-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ls-xs-margin-left"
  }, [_vm._v(_vm._s(_vm.$t('application.button.new_contract')))])])], 1), _vm._v(" "), (_vm.contracts.length) ? _c('div', [_c('a', {
    staticClass: "ls-btn-primary ls-no-margin ls-xs-margin-bottom ls-xs-margin-left",
    on: {
      "click": _vm.downloadCsv
    }
  }, [_vm._v(_vm._s(_vm.$t('contracts.main.export_csv')))])]) : _vm._e()], 1)]), _vm._v(" "), _c('flash-message'), _vm._v(" "), _c('br', {
    attrs: {
      "clear": "all"
    }
  }), _vm._v(" "), _c('filter-contract'), _vm._v(" "), (_vm.contracts.length) ? _c('div', [_c('div', [(_vm.activeSelected.length) ? _c('div', {
    staticClass: "ls-box-filter selected-items"
  }, [_c('p', {
    staticClass: "ls-txt-center ls-display-inline-block"
  }, [_vm._v(_vm._s(_vm.$root.plural(_vm.activeSelected.length, 'contracts.main.selected_items')))]), _vm._v(" "), _c('button', {
    staticClass: "ls-btn-danger ls-float-right",
    on: {
      "click": function($event) {
        _vm.setInactiveBatchData($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$root.plural(_vm.activeSelected, 'contracts.main.inactive_subscription')))])]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "ls-table ls-table-striped ls-sm-space"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "5%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAll),
      expression: "selectAll"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.activeContracts === 0
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAll) ? _vm._i(_vm.selectAll, null) > -1 : (_vm.selectAll)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.selectAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.selectAll = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.selectAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAll = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs",
    attrs: {
      "width": "8%"
    }
  }, [_vm._v(_vm._s(_vm.$t('contracts.attributes.id')))]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs",
    attrs: {
      "width": "8%"
    }
  }, [_vm._v(_vm._s(_vm.$t('contracts.attributes.code')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('contracts.main.client')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('contracts.main.subscription_value')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('contracts.main.charge_type')))]), _vm._v(" "), _c('th', {
    staticClass: "hidden-sm hidden-md hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('contracts.main.contract_date')))]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('contracts.main.status')))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredContracts(_vm.contracts)), function(contract, index) {
    return _c('tr', {
      attrs: {
        "data-test": "contract"
      }
    }, [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.activeSelected),
        expression: "activeSelected"
      }],
      attrs: {
        "data-test": "contract.select",
        "type": "checkbox",
        "disabled": contract.status !== 'active',
        "id": contract.id,
        "number": ""
      },
      domProps: {
        "value": index,
        "checked": Array.isArray(_vm.activeSelected) ? _vm._i(_vm.activeSelected, index) > -1 : (_vm.activeSelected)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.activeSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = index,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.activeSelected = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.activeSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.activeSelected = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs",
      attrs: {
        "data-test": "contract.id"
      }
    }, [_vm._v(_vm._s(contract.id))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs",
      attrs: {
        "data-test": "contract.code"
      }
    }, [_vm._v(_vm._s(contract.code))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-test": "contract.customer.name"
      }
    }, [_vm._v("\n            " + _vm._s(contract.customer.name) + "\n            "), _c('small', {
      staticClass: "ls-display-block",
      attrs: {
        "data-test": "contract.customer.email"
      }
    }, [_vm._v(_vm._s(contract.customer.email))])]), _vm._v(" "), _c('td', {
      attrs: {
        "data-test": "contract.plan.price"
      }
    }, [_vm._v("R$ " + _vm._s(_vm.money.parseViewValue(_vm.contractAmountValue(contract.contract_plans))))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-test": "contract.corp"
      }
    }, [_vm._v(_vm._s(_vm.$t('contracts.attributes.charge_types.' + _vm.chargeType(contract))))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-sm hidden-md hidden-xs",
      attrs: {
        "data-test": "contract.date"
      }
    }, [_vm._v(_vm._s(_vm.subscriptionDate(contract)))]), _vm._v(" "), _c('td', {
      class: 'hidden-xs ' + contract.status,
      attrs: {
        "data-test": "contract.status"
      }
    }, [_c('span', {
      staticClass: "ls-display-inline-block"
    }, [_vm._v(_vm._s(_vm.$t('contracts.attributes.statuses.' + contract.status)))])]), _vm._v(" "), _c('td', [_c('regroup', {
      staticClass: "ls-float-right",
      attrs: {
        "width": 970
      }
    }, [_c('router-link', {
      staticClass: "ls-btn ls-no-margin",
      attrs: {
        "to": {
          name: 'contract_details',
          params: {
            id: contract.id
          }
        }
      },
      slot: "button"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('application.button.detail')))])]), _vm._v(" "), _c('dropdown', {
      class: 'ls-pos-right',
      attrs: {
        "list": true
      },
      slot: "dropdown"
    }, [_c('button', {
      staticClass: "ls-btn ls-no-margin",
      attrs: {
        "role": "combobox",
        "aria-expanded": "false"
      },
      slot: "trigger"
    }), _vm._v(" "), _c('ul', {
      staticClass: "ls-dropdown-nav",
      attrs: {
        "aria-hidden": "true"
      },
      slot: "list"
    }, [(contract.status === 'active') ? _c('li', [_c('authorized-link', {
      attrs: {
        "tag": "destroy_contract"
      }
    }, [_c('a', {
      staticClass: "ls-color-danger",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.setInactiveData(contract, index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('application.button.inactive')))])])], 1) : _vm._e()])])], 1)], 1)])
  }))]), _vm._v(" "), _c('modal-inactive', {
    model: {
      value: (_vm.inactiveObjects),
      callback: function($$v) {
        _vm.inactiveObjects = $$v
      },
      expression: "inactiveObjects"
    }
  }), _vm._v(" "), _c('modal-inactive-batch', {
    model: {
      value: (_vm.inactiveBatchObjects),
      callback: function($$v) {
        _vm.inactiveBatchObjects = $$v
      },
      expression: "inactiveBatchObjects"
    }
  })], 1) : _c('div', {
    attrs: {
      "role": "alert"
    }
  }, [_c('empty-list')], 1), _vm._v(" "), _c('pagination', {
    attrs: {
      "updater": _vm.getContracts
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60e74dd9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/contracts/Main.vue
// module id = 788
// module chunks = 1